import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TableCard } from "@/components/ui/table-card";
import { CategoryRow } from "./CategoryRow";
import type { Category } from "@/types";

interface CategoryTableProps {
  categories: Category[];
}

export function CategoryTable({ categories }: CategoryTableProps) {
  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nazwa</TableHead>
            <TableHead>ID</TableHead>
            <TableHead className="w-24">Kolejność</TableHead>
            <TableHead className="w-24">Akcje</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {categories.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="py-12 text-center text-sm text-muted-foreground">
                Brak kategorii. Dodaj pierwszą kategorię.
              </TableCell>
            </TableRow>
          ) : (
            categories.map((category) => <CategoryRow key={category.id} category={category} />)
          )}
        </TableBody>
      </Table>
    </TableCard>
  );
}
